<ng-container *ngIf="data?.userHasRequestInProcess === true">
  <div class="current-flow">
    <h3>Proceso de solicitud</h3>
    <p>Continua con tu proceso de solicitud o validación de información.</p>
    <a [routerLink]="'/verify-documents'">Continuar</a>
  </div>
</ng-container>
